import {
  buildRequestedParameterIntents,
  type RequestedParameterIntentInput,
} from '../../api/grpc/requestedParameterIntent';
import type { ConnectorParameterDestination } from '../../types';
import {
  extractBoltParameterNames,
  getBoltFamilyVerificationParameterNames,
  type BoltConfigurationInput,
} from './planner';

export interface BoltFamilySnapshotRequest {
  parameterNames: string[];
  requestedParameters: RequestedParameterIntentInput[];
}

export function buildBoltFamilySnapshotRequest(
  configuration: BoltConfigurationInput,
  objectTypeDestination: ConnectorParameterDestination
): BoltFamilySnapshotRequest {
  const boltParameterNames = extractBoltParameterNames(configuration);
  const parameterNames = getBoltFamilyVerificationParameterNames(
    boltParameterNames,
    configuration.objectTypeParameterName
  );
  const normalizedObjectTypeName = configuration.objectTypeParameterName.trim().toLowerCase();
  return {
    parameterNames,
    requestedParameters: buildRequestedParameterIntents([
      {
        parameterNames: parameterNames.filter(
          (name) => name.trim().toLowerCase() !== normalizedObjectTypeName
        ),
        destination: configuration.parameterDestination,
        bindingKind: configuration.parameterBindingKind,
      },
      {
        parameterNames: [configuration.objectTypeParameterName],
        destination: objectTypeDestination,
        bindingKind: configuration.objectTypeBindingKind,
      },
    ]),
  };
}
